import { Button } from '@/components/shared/Button';

interface DiscordLoginButtonProps {
  onClick: () => Promise<void> | void;
}

export function DiscordLoginButton({ onClick }: DiscordLoginButtonProps): JSX.Element {
  return (
    <Button className="discord-button" fullWidth onClick={() => void onClick()}>
      <span className="discord-button__icon" aria-hidden="true">
        <img className="discord-button__icon-image" src="/assets/brand/discord.png" alt="" />
      </span>
      Continue with Discord
    </Button>
  );
}
